var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isApp && _vm.pdfUrl)?_c('object',{key:_vm.pdfUrl,staticClass:"rounded border-white",attrs:{"width":"100%","height":"400px","data":_vm.pdfUrl}}):_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("PDF Öffnen")])
}
var staticRenderFns = []

export { render, staticRenderFns }